module.exports = __webpack_public_path__ + "img/message.fd98d6cb.svg";